import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../Share/Network/FetchModule';

import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';
import PaymentOptionSettingSelectBox from '../../../MemberRegistration/Model/NewPaymentOptionSettingSelectBox';
import PaymentOptionCustomInput from '../../../MemberRegistration/Component/NewPaymentOptionCustomInput';
import ColorCustomInput from '../../../MemberRegistration/Component/ColorCustomInput';
import AddPaymentOptionModal from '../../../MemberRegistration/Model/AddPaymentOptionModal';
import NewProductCountInput from '../../../Component/MemberComponent/NewProductCountInput';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import { ReactComponent as LeftArrowSvg } from '../../../image/LeftArrow.svg';

const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

export default function WaitingProductPaymentModal(props) {
  const { userData, productData, onComplete, closeFn } = props;

  const history = useHistory();

  const [selectedProduct, setSelectedProduct] = useState(undefined);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [count, setCount] = useState(userData?.quantity || 1);

  const [discount, setDiscount] = useState(0);
  const [notReceived, setNotReceived] = useState(0);

  const [paymentOptions, setPaymentOptions] = useState(DefaultPaymentOption);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          setPaymentOptions(DefaultPaymentOption.concat(responseData.data.paymentOptions));
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, []);

  // 초기 상품 선택: userData.itemName과 일치하는 상품 //
  useEffect(() => {
    if (!productData || productData.length === 0) return;

    const matched = productData.find(p => p.name === userData.itemName);

    if (matched) setSelectedProduct(matched);
  }, [productData, userData]);

  // 결제 정보 불러와서 결제수단 자동 세팅 //
  useEffect(() => {
    if (!userData || !userData.merchantUid) return;

    const merchantUid = userData.merchantUid;
    const type = merchantUid.split('-')[2];

    const fetchModule = new FetchModule();
    (
      async () => {
        let responseData;

        if (type === '0') {
          responseData = await fetchModule.postData('sales/merchant_auto_data/', 'POST', { merchantUid });
        }
        else {
          responseData = await fetchModule.postData('sales/merchant_data/' + merchantUid, 'POST');
        }

        if (responseData.status === 200 && responseData.data[0]) {
          const salesData = responseData.data[0];
          let newPaymentOptions = [];

          if (salesData.cashPrice > 0) newPaymentOptions.push({ id: 0, name: '현금', price: salesData.cashPrice });
          if (salesData.cardPrice > 0) newPaymentOptions.push({ id: 0, name: '카드', price: salesData.cardPrice });
          if (salesData.point > 0) newPaymentOptions.push({ id: 0, name: '포인트', price: salesData.point });
          if (newPaymentOptions.length === 0) newPaymentOptions.push({ id: 0, name: '현금', price: 0 });

          setSelectedPaymentOptions(newPaymentOptions);
        }
      }
    )();
  }, [userData]);

  // 미수금 산정 //
  useEffect(() => {
    if (!selectedProduct) {
      setNotReceived(0);
      return;
    }

    let totalPaid = 0;

    for (const opt of selectedPaymentOptions) {
      if (opt.price !== '' && opt.price !== undefined) {
        const parsed = parseInt(opt.price.toString().replaceAll(',', ''));

        if (!isNaN(parsed)) totalPaid += parsed;
      }
    }

    if (discount !== '' && discount !== undefined) {
      const parsedDiscount = parseInt(discount.toString().replaceAll(',', ''));

      if (!isNaN(parsedDiscount)) totalPaid += parsedDiscount;
    }

    setNotReceived(Math.max((selectedProduct.price * count) - totalPaid, 0));
  }, [selectedProduct, count, selectedPaymentOptions, discount]);

  // 결제수단 변경시 //
  function onChangeSelectedPaymentOption(data, index) {
    const newOptions = selectedPaymentOptions.slice();

    newOptions[index].id = data.id;
    newOptions[index].name = data.name;
    setSelectedPaymentOptions(newOptions);
  }

  // 결제수단 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    const newOptions = selectedPaymentOptions.slice();

    newOptions[index].price = value.replaceAll(',', '');
    setSelectedPaymentOptions(newOptions);
  }

  // 결제수단 추가 버튼 클릭시 //
  function onClickAddPaymentOption() {
    const newOptions = [...selectedPaymentOptions, { id: 0, name: '현금', price: 0 }];

    setSelectedPaymentOptions(newOptions);
  }

  // 결제수단 삭제 버튼 클릭시 //
  function onClickDeletePaymentOption(index) {
    const newOptions = selectedPaymentOptions.slice();

    newOptions.splice(index, 1);
    setSelectedPaymentOptions(newOptions);
  }

  // 결제수단 추가 모달 저장 버튼 클릭시 //
  function onClickSavePaymentOptionModal(optionName) {
    if (optionName === '') {
      alert('결제수단의 이름을 입력해주세요');
      return;
    }

    if (isLoading) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsLoading(true);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', { optionName });

        if (responseData.status === 200) {
          setPaymentOptions(DefaultPaymentOption.concat(responseData.data.paymentOptions));
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제수단 목록에서 삭제 버튼 클릭시 //
  function onClickDeleteOptionFromList(paymentOptionId) {
    if (isLoading) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsLoading(true);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', { paymentOptionId });

        if (responseData.status === 200) {
          setPaymentOptions(DefaultPaymentOption.concat(responseData.data.paymentOptions));
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 드롭다운 상품 선택시 //
  function onClickProductItem(e, product) {
    e.stopPropagation();
    setSelectedProduct(product);
    setIsProductDropdownOpen(false);
  }

  // 저장 버튼 클릭시 //
  function onClickSave() {
    if (!selectedProduct) {
      alert('상품을 선택해주세요');
      return;
    }
    if (isLoading) return;

    const storeId = window.sessionStorage.getItem('StoreId');
    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    const finalSelectedPaymentOptions = selectedPaymentOptions.filter(
      opt => opt.price !== '' && opt.price !== 0 && opt.price !== undefined
    );

    let customOptionTotal = 0;

    for (const opt of finalSelectedPaymentOptions) {
      const price = parseInt(opt.price.toString().replaceAll(',', ''));

      if (isNaN(price)) continue;

      if (opt.id === 0) {
        if (opt.name === '현금') finalCashPrice += price;
        else if (opt.name === '카드') finalCardPrice += price;
        else if (opt.name === '포인트') finalPoint += price;
      }
      else {
        customOptionTotal += price;
      }
    }

    const discountPrice = parseInt(discount.toString().replaceAll(',', '')) || 0;

    const requestData = {
      id: -1,
      storeId: parseInt(storeId),
      memberId: parseInt(userData.memberId),
      productId: selectedProduct.id,
      merchantUid: userData.merchantUid,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice + customOptionTotal,
      discountPrice: discountPrice,
      notReceivedPrice: notReceived,
      point: finalPoint,
      count: count || 1,
      approvalDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
    };

    setIsLoading(true);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('product/usage/save', 'POST', requestData);

        if (responseData.status === 200) {
          alert('물품구매가 완료되었습니다.');
          setIsLoading(false);
          if (onComplete) onComplete();
        }
        else if (responseData.status === 401) {
          alert('로그인 후 사용해주세요.');
          history.push('/');
        }
        else {
          alert('저장에 실패했습니다. 다시 시도해주세요.');
          setIsLoading(false);
        }
      }
    )();
  }

  if (!userData) return null;

  const productPicture = selectedProduct
    ? (selectedProduct.picture || 'https://picture.link-zone.org/DefaultLogo.png')
    : (userData.itemPicture || 'https://picture.link-zone.org/DefaultLogo.png');

  const productPrice = selectedProduct ? (selectedProduct.price * count).toLocaleString('ko-KR') : '0';

  return (
    <TotalModalWrapper>
      {
        isClickedAddPaymentOption &&
        <AddPaymentOptionModal
          onClickSave={onClickSavePaymentOptionModal}
          onClickExit={() => setIsClickedAddPaymentOption(false)} />
      }
      <ModalView>
        <HeaderRow>
          <HeaderTextWrapper>
            <TitleText>{userData.userName} - 구입 희망 상품</TitleText>
          </HeaderTextWrapper>
        </HeaderRow>
        <ProductRow>
          <ProductImage src={productPicture} alt='product' />
          <ProductSelectWrapper onClick={() => setIsProductDropdownOpen(prev => !prev)}>
            <ProductSelectTextWrapper>
              <ProductSelectText hasValue={!!selectedProduct}>
                {selectedProduct ? selectedProduct.name : '상품 선택'}
              </ProductSelectText>
            </ProductSelectTextWrapper>
            <DropdownArrow isOpen={isProductDropdownOpen}>
              <StyledDownArrowSvg isOpen={isProductDropdownOpen} />
            </DropdownArrow>
            {
              isProductDropdownOpen &&
              <DropdownList>
                {
                  productData && productData.map((p, idx) => (
                    <DropdownItem
                      key={'ProductDropdown-' + idx}
                      onClick={(e) => onClickProductItem(e, p)}>
                      {
                        p.picture && p.picture !== '' &&
                        <DropdownItemImage src={p.picture} alt={p.name} />
                      }
                      <DropdownItemText>{p.name}</DropdownItemText>
                    </DropdownItem>
                  ))
                }
              </DropdownList>
            }
          </ProductSelectWrapper>
        </ProductRow>
        <InfoRow>
          <InfoSection>
            <InfoLabel>구매 개수</InfoLabel>
            <NewProductCountInput value={count} setValue={setCount} />
          </InfoSection>
          <InfoSection>
            <InfoLabel>물품 가격</InfoLabel>
            <PriceReadonlyWrapper>
              <PriceReadonlyText>{productPrice}</PriceReadonlyText>
              <UnitText>원</UnitText>
            </PriceReadonlyWrapper>
          </InfoSection>
        </InfoRow>
        {
          selectedPaymentOptions.map((opt, index) => (
            <PaymentRow
              key={'payment-' + index}
              style={{ zIndex: selectedPaymentOptions.length - index }}>
              <InfoSection>
                <InfoLabelRow>
                  <InfoLabel>결제 수단{index > 0 ? ` ${index + 1}` : ''}</InfoLabel>
                  {
                    index > 0 &&
                    <DeleteButton onClick={() => onClickDeletePaymentOption(index)}>
                      <DeleteIcon src={WhiteTrashIcon} />
                    </DeleteButton>
                  }
                </InfoLabelRow>
                <PaymentOptionSettingSelectBox
                  index={index}
                  value={opt}
                  setValue={onChangeSelectedPaymentOption}
                  options={paymentOptions}
                  disabled={paymentOptions.length === 0}
                  width={111}
                  onClickAdditionOption={() => setIsClickedAddPaymentOption(true)}
                  onClickDeleteOption={onClickDeleteOptionFromList} />
              </InfoSection>
              <InfoSection>
                <InfoLabel>받은 가격</InfoLabel>
                <UnitInputWrapper>
                  <PaymentOptionCustomInput
                    index={index}
                    value={(opt.price ?? 0).toLocaleString('ko-KR')}
                    setValue={onChangePaymentOptionPrice}
                    placeholder='0'
                    disabled={false}
                    textAlign='right' />
                  <UnitText>원</UnitText>
                </UnitInputWrapper>
              </InfoSection>
            </PaymentRow>
          ))
        }
        <AddPaymentButton onClick={onClickAddPaymentOption}>+ 결제 수단 추가</AddPaymentButton>
        <InfoRow>
          <InfoSection>
            <InfoLabel>할인 금액</InfoLabel>
            <UnitInputWrapper>
              <ColorCustomInput
                value={discount.toLocaleString('ko-KR')}
                setValue={setDiscount}
                placeholder='0'
                disabled={false}
                textAlign='right'
                color='#6DD49E' />
              <UnitText>원</UnitText>
            </UnitInputWrapper>
          </InfoSection>
          <InfoSection>
            <InfoLabel>미수금 금액</InfoLabel>
            <PriceReadonlyWrapper>
              <PriceReadonlyText color='#D92828'>{notReceived.toLocaleString('ko-KR')}</PriceReadonlyText>
              <UnitText>원</UnitText>
            </PriceReadonlyWrapper>
          </InfoSection>
        </InfoRow>
        <FooterRow>
          <CancelButton onClick={closeFn}>닫기</CancelButton>
          <SaveButton onClick={onClickSave} disabled={isLoading}>저장 하기</SaveButton>
        </FooterRow>
      </ModalView>
    </TotalModalWrapper>
  );
}

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  padding: 20px;

  width: 430px;

  gap: 10px;

  border-radius: 10px;
  background-color: #FFFFFF;
`;

const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;
`;

const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleText = styled.p`
  margin: 0;

  font-family: NotoSansKR-Bold;
  font-size: 16px;
  color: #232323;
`;

const StyledDownArrowSvg = styled(LeftArrowSvg)`
  width: 10px;
  height: auto;

  transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(-90deg)'};
  transition: transform 0.2s ease-in-out;
`;

const ProductRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ProductImage = styled.img`
  width: 50px;
  height: 50px;

  border-radius: 10px;
`;

const ProductSelectWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 5px 10px;

  width: 100%;

  border: 1px solid #E0E0E0;
  border-radius: 8px;
  background-color: #FFFFFF;

  cursor: pointer;
`;

const ProductSelectTextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  align-items: center;

  height: 40px;
`;

const ProductSelectText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.hasValue ? '#232323' : '#B2B2B2'};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  flex: 1;
`;

const DropdownArrow = styled.span`
  display: flex;

  align-items: center;

  margin-left: 8px;
`;

const DropdownList = styled.div`
  position: absolute;

  top: calc(100% + 4px);
  left: 0;

  width: 100%;
  max-height: 200px;

  border: 1px solid #E0E0E0;
  border-radius: 8px;
  background-color: #FFFFFF;

  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;

  z-index: 100;
`;

const DropdownItem = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;

  padding: 8px 12px;

  gap: 8px;

  cursor: pointer;

  &:hover {
    background-color: #F5F5F5;
  }
`;

const DropdownItemImage = styled.img`
  width: 50px;
  height: 50px;

  border-radius: 10px;
  object-fit: cover;

  flex-shrink: 0;
`;

const DropdownItemText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: #232323;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 10px 0 10px 0;

  width: 100%;

  gap: 10px;
`;

const PaymentRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  padding: 10px 0 10px 0;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;

  gap: 6px;

  width: 100%;
`;

const InfoLabelRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  gap: 8px;
`;

const InfoLabel = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;
  color: ${props => props.color || '#232323'};
  margin: 0;
`;

const PriceReadonlyWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 10px;

  height: 50px;

  gap: 5px;

  box-sizing: border-box;
`;

const PriceReadonlyText = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 17px;
  color: ${props => props.color || '#232323'};
`;

const UnitText = styled.span`
  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 17px;
  color: ${props => props.color || '#777777'};
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const AddPaymentButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  border-radius: 20px;
  background-color: #F2F2F2;

  font-family: NotoSansKR-Bold;
  font-size: 14px;
  color: #CBCBCB;

  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #FFFFFF;
    background-color: #6DD49E;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: #EC9393;

  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #D92828;
  }
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const FooterRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  gap: 10px;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 90px;
  height: 48px;

  border-radius: 10px;
  background-color: #F5F6F8;

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  color: #3E4148;

  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #E8E9EB;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex: 1;
  height: 48px;

  border-radius: 10px;
  background-color: ${props => props.disabled ? '#CBCBCB' : '#6DD49E'};

  font-family: NotoSansKR-Medium;
  font-size: 14px;
  color: #FFFFFF;

  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${props => props.disabled ? '#CBCBCB' : '#5BD98A'};
  }
`;
